module.exports = __webpack_public_path__ + "assets/img/img-hotel-18.0066cd4c.jpg";